<template>
 <div class="app-container">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="formItemBox">
              <el-form-item label="转货单号:" prop="changeNo">
                <el-input  placeholder="" v-model="searchFrom.changeNo"></el-input>
              </el-form-item>
              <el-form-item label="新客户名称:" prop="newCustomerName">
                <el-input  placeholder="" v-model="searchFrom.newCustomerName"></el-input>
              </el-form-item>
              <el-form-item label="货权方:" prop="ownerCustomerName" v-if="tableArr[1]">
                <el-input  placeholder="" v-model="searchFrom.ownerCustomerName"></el-input>
              </el-form-item>
              <el-form-item label="控货方:" prop="oneCustomerName" v-if="tableArr[0]">
                <el-input  placeholder="" v-model="searchFrom.oneCustomerName"></el-input>
              </el-form-item>
              <!-- <el-form-item label="转货单状态:" prop="status">
              <el-select v-model="searchFrom.status" placeholder="全部">
                <el-option  label="全部" value="" ></el-option>
                <el-option  label="处理中" value="1" ></el-option>
                <el-option  label="已完成" value="2" ></el-option>
              </el-select>
              </el-form-item> -->
               <el-form-item label="转货单状态:" prop="status">
              <el-select v-model="searchFrom.status" placeholder="请选择">
                <el-option  label="请选择" value="" ></el-option>
                <el-option  label="审核中" value="1001" ></el-option>
                <el-option  label="审核驳回" value="1002" ></el-option>
                <el-option  label="处理中" value="1011" ></el-option>
                <el-option  label="己完成" value="1021" ></el-option>
              </el-select>
            </el-form-item>
              <el-form-item label="创建时间:" prop="createTime">
                <el-date-picker
                  v-model="searchFrom.createTime"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
        </div>
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
                 <el-form-item >
                  <el-button type="primary"  @click="exportFn" :disabled="isDisable">导出</el-button>
                </el-form-item>
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border v-if="tableArr.length>0"  class="tableComent">
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="120">
            <template slot-scope="scope">
             <el-button type="text" size="mini"  v-if="scope.row.status==1002" @click="recallFn(scope.row)">删除</el-button>
            </template>
        </el-table-column>
        <el-table-column prop="changeNo"  min-width="220" :formatter="emptyFn" label="转货单号">
          <template slot-scope="scope">
            <span style="color: #0c46a2;cursor: pointer;" @click="detailsFn(scope.row)">{{scope.row.changeNo}}</span>
          </template>
        </el-table-column>
        <el-table-column label="转货函" width="120">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="lookFn(scope.row)">查看</el-button>
            </template>
        </el-table-column>
        <el-table-column width="120" prop="status" :formatter="statusFormat" label="转单状态"></el-table-column>
        <el-table-column prop="ownerCustomerName"  min-width="200" v-if="tableArr[1]" :formatter="emptyFn" label="货权方"></el-table-column>
        <el-table-column prop="oneCustomerName"  min-width="200" v-if="tableArr[0]" :formatter="emptyFn" label="控货方"></el-table-column>
        <el-table-column prop="newCustomerName"  min-width="220" :formatter="emptyFn" label="新客户名称"></el-table-column>
        <el-table-column prop="plan"  min-width="180" :formatter="emptyFn" label="转货量(吨/件)">
          <template scope="scope">
            <div>
              {{scope.row.planWeight}} / {{scope.row.planNum}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="actual"  width="180" :formatter="emptyFn" label="实转量(吨/件)">
          <template scope="scope">
            <div>
              {{scope.row.actualWeight}} / {{scope.row.actualNum}}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="organizationName" width="240" label="所在仓库"></el-table-column>
        <el-table-column prop="createUserName"  width="150" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime"  min-width="200" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { getBtn, getAttribute } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { SVClist, findExtAttritude, SVCdelete } from '@/api/soc-stock-cosco'
import { getSBillFileUrl } from '@/api/soc-stock'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  data () {
    return {
      tableArr: [],
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      goodTypes: [],
      isDisable: false,
      btnFlg: [],
      btnIdArr: ['004P003B000', '004P003B001', '004P003B002']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/ZYtransferGoodsBill')
    this.tableArr = getAttribute('ARRoneCustomerName,ARRownerCustomerName')
    if (localStorage.getItem('isCutCrm3') == 1) {
      this.$set(this.searchFrom, 'organizationId', localStorage.getItem('createTenantCode'))
    }
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 168) + 'px'
  },
  methods: {
    // 导出
    exportFn () {
      let falg = this.tableArr[0]
      let form = this.searchFrom
      form.oneCustomerNameFlag = falg
      form.ownerCustomerNameFlag = this.tableArr[1]
      exportExcel(
        this.global.stockName + '/sVirtualChange/virtualChangeExport',
        form,
        '转货单据'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查看
    // lookFN (row) {
    //   getCVehicleInfoListByDriverId({ driverId: row.id }).then(res => {
    //     this.dialogVisible = true
    //     this.carList = res
    //   })
    // },
    // 查看转货函
    lookFn (row) {
      if (row.fileUrl) {
        let formData = new FormData()
        formData.append('url', row.fileUrl)
        getSBillFileUrl(formData).then(res => {
          this.$router.push({
            name: 'Pdf',
            query: { path: res }
          })
        })
      } else {
        this.$alert('暂无转货函', '系统提示')
      }
    },
    // 详情
    detailsFn (row) {
      this.$router.push({ name: 'ZYtransferGoodsBillDetails', query: { id: row.id } })
    },
    // 查选
    // searchFn () {
    //   if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }
    //   this.getList(this.searchFrom)
    // },
    searchFn () {
      if (this.searchFrom.billNo) { this.searchFrom.billNos = this.searchFrom.billNo.split(/[(\r\n)\r\n]+/) } else {
        this.searchFrom.billNos = ''
      }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      SVClist(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
      if (localStorage.getItem('isCutCrm3') == 1) {
        this.$set(this.searchFrom, 'organizationId', localStorage.getItem('createTenantCode'))
      }
    },
    // 删除
    recallFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        SVCdelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    closeDialog () {
      this.addFrom = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
    },
    // 状态格式化
    statusFormat (row, column, cellValue) {
      switch (cellValue) {
        case 1001:
          return '审核中'
        case 1002:
          return '审核驳回'
        case 1011:
          return '处理中'
        case 1021:
          return '已完成'
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
  width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
</style>
